import script from "./SupplierSelectsUseInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupplierSelectsUseInput.vue?vue&type=script&setup=true&lang=ts"

import "./SupplierSelectsUseInput.vue?vue&type=style&index=0&id=1ce42126&scoped=true&lang=css"
import "./SupplierSelectsUseInput.vue?vue&type=style&index=1&id=1ce42126&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ce42126"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QChip,QItem,QItemSection,QField});
